<template>
  <div class="flex q-ma-lg justify-center">
    <p class="text-italic">{{ greet }}</p>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue';

export default { name: 'DashboardView' };
</script>
<script setup lang="ts">

const greet = ref('Бобро пожаловац');
</script>

<style scoped>

</style>
